import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useProjectsList } from '../../../../contexts/ProjectsContext';
import { useSidebar } from '../../../shared/contexts/SidebarContext';
import Header from '../../../shared/components/layout/Header';
import Layout from '../../components/layout/AppLayout';
import FormInput from '../../../shared/components/ui/FormInput';
import SalesUnitInventoryList from './SalesUnitInventoryList';
import Loader from '../../../shared/components/ui/Loader';

const SalesUnitInventory = () => {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const { projectsForDropdown, isProjectsLoading } = useProjectsList();
  const { collapsed } = useSidebar();
  const {
    register,
    setValue,
    watch,
    formState: { errors }
  } = useForm();

  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const projectFieldValue = watch('project');

  useEffect(() => {
    if (projectsForDropdown?.length > 0) {
      if (projectId) {
        setValue('project', parseInt(projectId, 10));
        setSelectedProjectId(parseInt(projectId, 10));
      } else if (!selectedProjectId) {
        const firstId = projectsForDropdown[0].value;
        setValue('project', firstId);
        setSelectedProjectId(firstId);
        navigate(`/builder/sales/unit-inventory/${firstId}`, { replace: true });
      } else {
        setValue('project', selectedProjectId);
      }
    }
  }, [projectsForDropdown, projectId, selectedProjectId, setValue, navigate]);

  useEffect(() => {
    if (projectFieldValue && projectFieldValue !== selectedProjectId) {
      const id = parseInt(projectFieldValue, 10);
      setSelectedProjectId(id);
      navigate(`/builder/sales/unit-inventory/${id}`);
    }
  }, [projectFieldValue, selectedProjectId, navigate]);

  if (!projectId) {
    return (
      <>
        <Loader isVisible={isProjectsLoading} message="Loading projects..." />
        <Layout>
          <div
            className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
              ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
            `}
          >
            <Header data={{ name: 'Sales > Unit Inventory' }} />
          </div>
          <div
            className={`flex items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm z-[10] transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'}`}
          >
            <div className="flex items-center gap-4 w-1/3">
              <FormInput
                width={100}
                label={''}
                register={register}
                register_key={'project'}
                isRequired={true}
                type={'dropdown'}
                options={[
                  { label: 'Select Project', value: '', disabled: true },
                  ...(projectsForDropdown || [])
                ]}
                errors={errors}
                hideAstrik={true}
                mb
              />
            </div>
          </div>
          <div className="mt-[9rem] h-[calc(100vh-9.5rem)] overflow-auto bg-gray-100 flex flex-col items-center justify-center">
            <h2 className="text-lg font-bold text-gray-800 mb-1">Select a project</h2>
            <p className="text-gray-600 text-sm">Choose a project to view unit pricing and inventory.</p>
          </div>
        </Layout>
      </>
    );
  }

  return (
    <Layout>
      <div
        className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
          ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
        `}
      >
        <Header data={{ name: 'Sales > Unit Inventory' }} />
      </div>
      <div
        className={`flex items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm z-[10] transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'}`}
      >
        <div className="flex items-center gap-4 w-1/3">
          <FormInput
            width={100}
            label={''}
            register={register}
            register_key={'project'}
            isRequired={true}
            type={'dropdown'}
            options={[
              { label: 'Select Project', value: '', disabled: true },
              ...(projectsForDropdown || [])
            ]}
            errors={errors}
            hideAstrik={true}
            mb
          />
        </div>
      </div>
      <div className="mt-[9rem] min-h-[calc(100vh-9.5rem)] overflow-auto bg-gray-100">
        <SalesUnitInventoryList />
      </div>
    </Layout>
  );
};

export default SalesUnitInventory;
